import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.error-message',
		defaultMessage: 'Something has gone wrong. An error has occurred.',
		description: 'error message displayed when metric update is failed',
	},
	errorTooltip: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.error-tooltip',
		defaultMessage: 'This SLA has one or more errors.',
		description:
			'message displayed in tooltip when a priority gets updated and still old value is being in a SLA',
	},
});
